import { stringToSVG } from '../../../utilities';

const svg = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 8L4 11L11 4" stroke="#082032"/>
<path d="M1 5L4 8L11 1" stroke="#082032"/>
</svg>
`;
export default stringToSVG(svg);